<div class="title">
  <p-heading [size]="'x-large'" [tag]="'h3'">Inventory Types</p-heading>

  <p-button
    [hideLabel]="(mediaMaxXs$ | async) ?? false"
    [iconSource]="'assets/icons/add.svg'"
    [variant]="'secondary'"
    (click)="showCreateModal = true"
  >
    Add New Type
  </p-button>
</div>

<p-divider aria-hidden="true" />

<section class="list">
  <p-heading *ngrxLet="data$ | async as types" [size]="'small'" [tag]="'h4'">
    {{ types?.length }} Types
  </p-heading>

  <ng-container *ngrxLet="data$ as data; error as dataError; suspenseTpl: spinner">
    <div *ngIf="dataError">
      <p-button-pure
        [hideLabel]="true"
        [iconSource]="'assets/icons/refresh.svg'"
        [size]="'large'"
        (click)="reloadData()"
      >
        Reload Types
      </p-button-pure>
    </div>

    <ng-container *ngIf="!dataError && data">
      <div class="overlay-spinner-host">
        <ng-container *ngIf="loading$ | async" [ngTemplateOutlet]="overlaySpinner" />

        <p-table caption="Inventory Type list table">
          <p-table-head>
            <p-table-head-row>
              <p-table-head-cell style="width: 1%">Edit</p-table-head-cell>
              <p-table-head-cell style="width: 68%">Name</p-table-head-cell>
              <p-table-head-cell style="width: 30%">Require IMEI</p-table-head-cell>
              <p-table-head-cell style="width: 1%">Delete</p-table-head-cell>
            </p-table-head-row>
          </p-table-head>

          <p-table-body>
            <p-table-row *ngFor="let type of data; trackBy: trackInventoryType">
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/edit.svg'"
                  [hideLabel]="true"
                  (click)="openEditModal(type)"
                >
                  Edit {{ type.description }}
                </p-button-pure>
              </p-table-cell>

              <p-table-cell>
                <p-link-pure [icon]="'none'" [underline]="true">
                  <a [routerLink]="['/inventory-items']" [queryParams]="{ typeId: type.id }">
                    {{ type.description }}
                  </a>
                </p-link-pure>
              </p-table-cell>
              <p-table-cell>
                <div
                  class="status"
                  [ngClass]="{
                    'status--active': type.imeiRequired,
                    'status--inactive': !type.imeiRequired,
                  }"
                ></div>
              </p-table-cell>
              <p-table-cell>
                <p-button-pure
                  [iconSource]="'assets/icons/delete.svg'"
                  [hideLabel]="true"
                  (click)="openDeleteModal(type)"
                >
                  Delete {{ type.description }}
                </p-button-pure>
              </p-table-cell>
            </p-table-row>
          </p-table-body>
        </p-table>
      </div>
    </ng-container>
  </ng-container>
</section>

<opa-inventory-type-create
  [open]="showCreateModal"
  (dismiss)="showCreateModal = false; $event && reloadData()"
/>

<ng-template #spinner>
  <div class="loading-spinner"><p-spinner /></div>
</ng-template>

<ng-template #overlaySpinner>
  <div class="overlay-spinner"><p-spinner /></div>
</ng-template>

<opa-inventory-type-delete
  [open]="showDeleteModal"
  [inventoryType]="(inventoryType$ | async) ?? undefined"
  (dismiss)="closeDeleteModal($event)"
/>

<opa-inventory-type-edit
  [open]="showEditModal"
  [inventoryType]="(inventoryType$ | async) ?? undefined"
  (dismiss)="closeEditModal($event)"
/>
